import { MerchantInformationCard as UIMerchantInformationCard, type MerchantInformationCardProps as UIMerchantInformationCardProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

export type MerchantInformationCardProps = Omit<
  UIMerchantInformationCardProps,
  'defaultTitle' | 'defaultSubtitle' | 'editInformationLabel' | 'fillInformationLabel'
>;

const MerchantInformationCard = (props: MerchantInformationCardProps) => {
  const { t } = useTranslation();
  return (
    <UIMerchantInformationCard
      {...props}
      defaultTitle={t('components.merchantInformationCard.defaultTitle')}
      defaultSubtitle={t('components.merchantInformationCard.defaultSubtitle')}
      editInformationLabel={t('components.merchantInformationCard.editInformation')}
      fillInformationLabel={t('components.merchantInformationCard.fillInformation')}
    />
  );
};

export default MerchantInformationCard;
